module.exports = __webpack_public_path__ + "img/ico-tel.c2d08518.svg";